import PropTypes from 'prop-types';

export default PropTypes.shape({
  EUR: PropTypes.number,
  GBP: PropTypes.number,
  USD: PropTypes.number
});
